import { render, staticRenderFns } from "./edit-location.vue?vue&type=template&id=55077834"
import script from "./edit-location.vue?vue&type=script&lang=js"
export * from "./edit-location.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports